import { Context, CustomQuery } from '@vue-storefront/core';
import { ApiResult } from '../../types';
// 配置文件查询
export default async function transAdd(context: Context, parms: CustomQuery): Promise<ApiResult> {
  // const url = new URL('/mall/article/get', context.config.api.url);
  const url = new URL('/mall/trans/add', context.config.api.url);
  const { data: res } = await context.client.post(url.href, parms);
  return res;
}
